import React from 'react';
import { Navigate } from 'react-router-dom';

import Error403 from '../../modules/errorPages/Error403';
import { initialUrl } from '@crema/constants/AppConst';

import { authRouteConfig } from './AuthRoutes';
import { errorPagesConfigs } from './ErrorPagesRoutes';
import { accountPagesConfigs } from './AccountRoutes';
import { channelProductConfigs } from './ChannelManagementRoutes';
import { designTemplateManagementConfigs } from './DesignTemplateManagementRoutes';
import { productManagementConfigs } from './ProductManagementRoutes';
import { designManagementConfigs } from './DesignManagementRoutes';
import { channelUserConfigs } from './ChannelUserRoutes';
import { orderManagementPageConfig } from './OrderManagementRoutes';
import { prepaymentConfigs } from './Prepayment';
import { editorConfigs } from './EditorRoutes';
import { StaticsConfigs } from './StaticsRoutes';
import { NoticeConfigs } from './NoticeRoutes';
import { PodProductConfigs } from './PodProductRoutes';
import { brandManagementConfigs } from './BrandManagementRoutes ';
import { thirdPartyAuthRoutesConfig } from './ThirdPartyAuthRoutes';
import { subChannelManagementConfigs } from './SubChannelManagementRoutes';
import { termsRoutesConfig } from './TermsRoutes';
import { d2cChannelRequestRoutesConfig } from './D2cChannelRequestRoutes';
import { storeConnectRoutesConfig } from './StoreConnectRoutes';

const authorizedStructure = {
  fallbackPath: '/signin',
  unAuthorizedComponent: <Error403 />,
  routes: [
    ...designManagementConfigs,
    ...channelProductConfigs,
    ...productManagementConfigs,
    ...accountPagesConfigs,
    ...designTemplateManagementConfigs,
    ...channelUserConfigs,
    ...orderManagementPageConfig,
    ...prepaymentConfigs,
    ...editorConfigs,
    ...StaticsConfigs,
    ...NoticeConfigs,
    ...PodProductConfigs,
    ...brandManagementConfigs,
    ...thirdPartyAuthRoutesConfig,
    ...subChannelManagementConfigs,
    ...d2cChannelRequestRoutesConfig,
    ...storeConnectRoutesConfig,
  ],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authRouteConfig,
};

const anonymousStructure = {
  routes: [
    ...errorPagesConfigs,
    ...termsRoutesConfig,
    {
      path: '/',
      element: <Navigate to={initialUrl} />,
    },
    {
      path: '*',
      element: <Navigate to="/signin" />,
    },
    ...thirdPartyAuthRoutesConfig,
  ],
};

export default {
  authorizedStructure,
  unAuthorizedStructure,
  anonymousStructure,
};
